module.exports = __webpack_public_path__ + "static/media/付费直播@2x.be3e87b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/付费直播@2x.png
// module id = 1534
// module chunks = 0